import React from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { useDispatch } from "react-redux";
import { RootDispatch } from "../../store";
import { getEntities } from "../../store/slices/Factory/copyBomSlice";

interface BOMAsyncSelectProps {
  from: "product" | "material";
  value: any;
  onChange: (value: any) => void;
}

const BOMAsyncSelect: React.FC<BOMAsyncSelectProps> = ({
  from,
  value,
  onChange,
}) => {
  const dispatch = useDispatch<RootDispatch>();

  const loadOptions = async (
    searchQuery: string,
    loadedOptions: any,
    additional?: { page?: number },
  ) => {
    const page = additional?.page ?? 1;

    try {
      const response = await dispatch(
        getEntities({
          params: {
            from,
            search: searchQuery,
            page,
            limit: 10,
          },
        }),
      ).unwrap();
      if (!response.success) {
        throw Error("Failed to fetch Entities");
      }

      const { data, pagination } = response;

      const options = data.map((item: any) => ({
        value: item.id,
        label: item.name,
        bomId: item.bomId,
      }));

      return {
        options,
        hasMore: page < (pagination?.totalPages || 1),
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      return {
        options: [],
        hasMore: false,
        additional: {
          page,
        },
      };
    }
  };

  return (
    <AsyncPaginate
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      additional={{ page: 1 }}
      placeholder={`Select ${from} to copy BOM from...`}
      isClearable
      className="text-sm"
    />
  );
};

export default BOMAsyncSelect;
